import React from "react";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import { LanguageContext } from "../../context/LanguageContext";
import * as XLSX from "xlsx-js-style";
import {
  Button,
  Col,
  DatePicker,
  Descriptions,
  Dropdown,
  Form,
  Menu,
  message,
  PageHeader,
  Row,
  Select,
} from "antd";
import moment from "moment";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  BarChartOutlined,
  DownOutlined,
  FilterOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
const { Option } = Select;

const formatCrimeTitles = (basicInfo) => {
  if (!Array.isArray(basicInfo) || !basicInfo.length) return "-";
  const titles = [];
  const seen = new Set();
  basicInfo.forEach((item) => {
    const title = (item?.title || "").trim();
    if (!title || seen.has(title)) return;
    seen.add(title);
    titles.push(title);
  });
  return titles.length ? titles.join(", ") : "-";
};

const groupKaydaKalam = (kkInfo) => {
  if (!Array.isArray(kkInfo) || !kkInfo.length) return [];
  const grouped = new Map();
  kkInfo.forEach((item) => {
    const rulesName = (item?.rulesName || "").trim() || "-";
    const kalam = (item?.kalam || "").trim();
    if (rulesName === "-" && !kalam) return;
    if (!grouped.has(rulesName)) grouped.set(rulesName, new Set());
    if (kalam) grouped.get(rulesName).add(kalam);
  });
  return [...grouped.entries()].map(([rulesName, kalams]) => ({
    rulesName,
    kalams: [...kalams],
  }));
};

const formatKaydaKalam = (kkInfo) => {
  const groups = groupKaydaKalam(kkInfo);
  return groups.length
    ? groups
        .map(
          (group) =>
            `${group.rulesName} - ${
              group.kalams.length ? group.kalams.join(", ") : "-"
            }`,
        )
        .join(" | ")
    : "-";
};

const TableReportGuna = React.lazy(() =>
  import("./Tables/GunaTable").then((module) => ({
    default: module.TableReportGuna,
  })),
);

class GunaReportPoliceAdmin extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
  }
  state = {
    total: 0,
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    total: 0,
    showList: "list",
    guna_count: 0,
    download: "excel",
    crime_count: 0,
    showFilterSection: false,
    direction: "",
    key: "",
  };
  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null, // reset end date when start changes
        isMoreThanOneYear: false,
      });
    } else {
      this.setState({
        report_4_startDate: null,
        report_4_endDate: null,
        isMoreThanOneYear: false,
      });
    }
  };

  onEndDateChange = (date) => {
    if (!date) return;

    this.setState({
      report_4_endDate: date.toISOString(),
    });
  };
  getData = () => {
    const { showList } = this.state;
    if (showList === "list") {
      this.getGunaReportPoliceSide();
    }
    if (showList === "count") {
      this.getGunareportByTitle();
    }
  };
  getGunareportByTitle = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    this.setState({
      loading: true,
    });
    const temp = {
      startDate: startDate,
      endDate: endDate,
      district: this.props.user.districtId,
    };
    professionalAction.getGunareportByTitle(temp).then((res) => {
      const data = res.results;
      const total = res.results.reduce(
        (acc, item) => acc + item.register_count,
        0,
      );

      this.setState({
        report4_List: data,
        total: total,
        loading: false,
      });
    });
  };
  getGunaReportPoliceSide = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    this.setState({
      loading: true,
    });
    const startDate = moment(report_4_startDate, "YYYY").format("YYYY");
    const endDate = moment(report_4_endDate, "YYYY").format("YYYY");

    const startDate1 = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate1 = moment(report_4_endDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );

    const temp = {
      startDate: startDate,
      endDate: endDate,
      district: this.props.user.districtId,
      startDate1: startDate1,
      endDate1: endDate1,
    };
    professionalAction.getGunaReportPoliceSide(temp).then((res) => {
      const sortedData = res.results.sort((a, b) => {
        const numA = parseInt(a.registernumber, 10) || 0;
        const numB = parseInt(b.registernumber, 10) || 0;
        return numA - numB;
      });

      this.setState({
        report4_List: sortedData,
        guna_count: res.summary?.totalRegisterNumberCount,
        crime_count: res.summary?.totalAccusedCount,
        loading: false,
      });
    });
  };
  getExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.report4_List;

    return this.state.showList === "list"
      ? arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("crime_register_number")]: data.registernumber,
          [t("crime_registration_date")]: data.dateTime
            ? moment(data.dateTime).format("DD-MM-YYYY")
            : "-",
          [t("title")]: formatCrimeTitles(data.basic_info),
          [`${t("law")} - ${t("section")}`]: formatKaydaKalam(data.kk_info),
          [t("total_accused")]: data.totalCrimeCount,
        })) || []
      : arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("heading")]: data.heading,
          [t("count")]: data.register_count,
        })) || [];
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("guna_register");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    console.log("this.props", this.props);
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download } = this.state;

    if (download === "excel") {
      this.download_csv();
    }
    if (download === "excel_guna") {
      this.download_guna_csv();
    }
    if (download === "pdf") {
      this.download_pdf();
    }
  };

  download_guna_csv = () => {
    const { showList } = this.state;
    const { t } = this.context;
    var ReportTitle = "आरोपी सहित गुन्हा रजिस्टर";
    var title = t("guna_register");
    var arrData1 = this.state.report4_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list = [];

    arrData1.forEach((data, index) => {
      const firstTitle =
        data.basic_info && data.basic_info.length > 0
          ? data.basic_info[0].title
          : "";

      if (data.basic_info && data.basic_info.length > 0) {
        data.basic_info.forEach((item, i) => {
          list.push({
            ["अ. क्र ."]: index + 1,
            ["गुन्हा नंबर"]: i === 0 ? data.registernumber : "",
            ["दिनांक"]:
              i === 0 ? moment(data.dateTime).format("DD-MM-YYYY") : "",

            ["शीर्षक"]: i === 0 ? firstTitle : "", // ✅ ONLY ONCE
            ["एकूण आरोपी"]: i === 0 ? data.totalCrimeCount : "",
            ["Master ID"]: item.masterId || "",
            ["नाव"]: item.name || "", // ✅ multiple rows
            ["एकुण गुन्हे"]: item.totalCount || "",
          });
        });
      } else {
        list.push({
          ["अ. क्र ."]: data + 1,
          ["गुन्हा नंबर"]: data.registernumber || "",
          ["दिनांक"]: data.dateTime
            ? moment(data.dateTime).format("DD-MM-YYYY")
            : "",
          ["शीर्षक"]: "",
          ["एकूण आरोपी"]: data.totalCrimeCount || 0,
          ["Master ID"]: "",
          ["नाव"]: "",
          ["एकुण गुन्हे"]: "",
        });
      }
    });

    const arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_4_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  componentDidMount() {
    const { user } = this.props;
    if (user && user.role !== "4") {
      this.getDistrictsid();
    }
    this.props.dispatch(professionalAction.getCity());
  }

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  download_csv = () => {
    const { showList } = this.state;
    const { t } = this.context;
    var ReportTitle = t("guna_register");
    var title = t("guna_register");
    var arrData1 = this.state.report4_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list =
      showList === "list"
        ? arrData1?.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("crime_register_number")]: data.registernumber,
            [t("crime_registration_date")]: data.dateTime
              ? moment(data.dateTime).format("DD-MM-YYYY")
              : "-",
            [t("title")]: formatCrimeTitles(data.basic_info),
            [`${t("law")} - ${t("section")}`]: formatKaydaKalam(data.kk_info),
            [t("total_accused")]: data.totalCrimeCount,
          }))
        : arrData1.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("heading")]: data.heading,
            [t("count")]: data.register_count,
          }));

    const arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_4_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });

    const { report4_List } = this.state;

    const sortedData = [...report4_List].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ report4_List: sortedData });
  };

  filterkey = (e) => {
    this.setState({ key: e.key });
  };
  render() {
    const { report_4_startDate, report_4_endDate, showList, direction, key } =
      this.state;
    const { language, t } = this.context;
    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        {this.state.showList == "list" ? (
          <>
            <Menu.Item key="totalCrimeCount">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                एकूण आरोपी
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "totalCrimeCount" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("totalCrimeCount", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "totalCrimeCount" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("totalCrimeCount", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
            <Menu.Item key="registernumber">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                गु.र.नंबर
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "registernumber" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("registernumber", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "registernumber" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("registernumber", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        ) : (
          <>
            <Menu.Item key="register_count">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                गणना
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "register_count" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("register_count", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "register_count" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("register_count", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        )}
      </Menu>
    );
    return (
      <>
        <PageHeader className="site-page-header" ghost={false} onBack={false}>
          <Row gutter={[16, 16]} align="middle">
            {/* Start Date Picker */}
            <Col xs={24} sm={12} md={6} lg={4}>
              <DatePicker
                style={{ width: "100%" }}
                value={report_4_startDate ? moment(report_4_startDate) : null}
                onChange={this.onStartDateChange}
                placeholder="DD/MM/YYYY"
                allowClear
                format="DD/MM/YYYY"
                inputReadOnly
              />
            </Col>

            {/* End Date Picker */}
            <Col xs={24} sm={12} md={6} lg={4}>
              <DatePicker
                style={{ width: "100%" }}
                value={report_4_endDate ? moment(report_4_endDate) : null}
                onChange={this.onEndDateChange}
                placeholder="DD/MM/YYYY"
                allowClear
                format="DD/MM/YYYY"
                inputReadOnly
              />
            </Col>

            {/* Find Button */}
            <Col xs={24} sm={24} md={6} lg={3}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                disabled={
                  !this.state.report_4_startDate || !this.state.report_4_endDate
                }
                onClick={this.getData}
              >
                {t("find")}
              </Button>
            </Col>

            {/* Download Select */}
            <Col xs={24} sm={12} md={4} lg={4}>
              <Select
                placeholder={t("please_select_an_option")}
                value={this.state.download || "excel"}
                onChange={(value) => this.setState({ download: value })}
                style={{ width: "100%" }}
              >
                <Option key="excel">{t("excel")}</Option>
                {this.state.showList === "list" && (
                  <Option key="excel_guna">आरोपी सहित गुन्हा रजिस्टर</Option>
                )}
                <Option key="pdf">PDF</Option>
              </Select>
            </Col>

            {/* Download Button */}
            <Col xs={12} sm={6} md={2} lg={4}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={this.downloadReport}
                disabled={!this.state.report4_List?.length}
              >
                {t("download")}
              </Button>
            </Col>
          </Row>

          {/* <div
            style={{
              marginTop: "16px",
              padding: "16px",
              background: "#fff",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Dropdown
                overlay={menu}
                disabled={!this.state.report4_List?.length}
                placement="bottomRight"
                arrow={{ pointAtCenter: true }}
                overlayStyle={{ width: "200px" }} // Smaller dropdown size
              >
                <Button
                  type="ghost" // Ant Design's default blue style
                  style={{
                    width: "120px", // Smaller button size
                    backgroundColor: "#1890ff", // Blue color
                    borderColor: "#1890ff",
                  }}
                  className="modern-button"
                >
                  {t("sorter_by")} <DownOutlined />
                </Button>
              </Dropdown>
            </div>
          </div> */}
        </PageHeader>
        <React.Suspense fallback={<div>Loading...</div>}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              alignItems: "center",
              padding: "12px",
              background: "#f5f5f5",
              borderRadius: "8px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {" "}
              <Button
                type={showList == "count" ? "primary" : "default"}
                icon={<BarChartOutlined />}
                style={{
                  minWidth: "120px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
                onClick={() => {
                  this.setState({
                    showList: "count",
                    report4_List: [],
                    download: "excel",
                  });
                }}
              >
                {t("statistics")}
              </Button>
              <Button
                type={showList == "list" ? "primary" : "default"}
                icon={<UnorderedListOutlined />}
                style={{
                  minWidth: "120px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
                onClick={() => {
                  this.setState({
                    showList: "list",
                    report4_List: [],
                    download: "excel",
                  });
                }}
              >
                {t("list")}
              </Button>
            </div>
          </div>

          <TableReportGuna
            key={this.state.report4_List}
            data={this.state.report4_List}
            total={this.state.total}
            startDate={this.state.report_4_startDate}
            endDate={this.state.report_4_endDate}
            district={this.props.user.districtId}
            showList={this.state.showList}
            guna_count={this.state.guna_count}
            crime_count={this.state.crime_count}
            loading={this.state.loading}
          ></TableReportGuna>
        </React.Suspense>
      </>
    );
  }
}
function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedGunaReportPoliceAdmin = connect(mapStateToProps)(
  GunaReportPoliceAdmin,
);
export { connectedGunaReportPoliceAdmin as GunaReportPoliceAdmin };
